import clsx from "clsx";
import styles from "properties/_css/propertiesViewButtonsMobile.module.css";
import React from "react";
import { Button } from "_common/ui/mui/buttons/Button";
import { PROPERTY_VIEW_STYLE } from "properties/components/BREAKPOINTS_SECTION_CARDS";
import { List, MapOutlined } from "@material-ui/icons";
import { useCommunitiesPageContext } from "communities/communities-listing/communities-view-context";

export function CommunitiesViewButtonMobile() {
    const { mapOrListSelected, setMapOrListSelected } = useCommunitiesPageContext();

    return (
        <div
            className={clsx(
                styles.container,
                "fixed w-full z-[800] bottom-5 md:hidden flex items-center justify-center gap-4 transform -translate-x-2.5",
            )}
        >
            <Button
                onClick={() =>
                    setMapOrListSelected(
                        mapOrListSelected === PROPERTY_VIEW_STYLE.MAP
                            ? PROPERTY_VIEW_STYLE.LIST
                            : PROPERTY_VIEW_STYLE.MAP,
                    )
                }
                color={"primary"}
                variant={"contained"}
            >
                <>
                    {mapOrListSelected === PROPERTY_VIEW_STYLE.MAP ? (
                        <List className="mr-[5px]" fontSize={"default"} />
                    ) : (
                        <MapOutlined className="mr-[5px]" fontSize={"default"} />
                    )}
                </>
                {mapOrListSelected === PROPERTY_VIEW_STYLE.MAP ? "List" : "Map"}
            </Button>
        </div>
    );
}
